import { useContext } from 'react';

import { app } from 'context';
import Layout from '../Layout';

import AddressAutocompleteResultRow from './AddressAutocompleteResultRow';

import poweredByGoogle from 'shared/assets/powered-by-google-on-white-hdpi.png';

interface Props {
  results: AddressAutocompleteResult[];
  onLocationSelect: (result: AddressAutocompleteResult) => void;
  isBottomSheet?: boolean;
  setSelectedResult?: (result: AddressAutocompleteResult) => void;
  searchValue?: string;
  focusedIndex: number;
  showGoogleAttribution: boolean;
}

export interface AddressAutocompleteResult {
  display: string;
  placeId: string;
}

const AddressAutocompleteResults = ({
  results,
  onLocationSelect,
  isBottomSheet,
  searchValue,
  focusedIndex,
  showGoogleAttribution
}: Props) => {
  const { isSmallPhone } = useContext(app);

  return (
    <Layout position="relative" {...(results.length ? { paddingBottom: 16 } : { height: 0 })}>
      <ul
        style={{
          listStyleType: 'none',
          padding: isSmallPhone ? '4px 0' : '8px 0',
          margin: 0
        }}
      >
        {results.map((result, index) => (
          <li
            key={result.placeId}
            data-cy={`location-result-${index}`}
            onClick={() => {
              onLocationSelect(result);
            }}
          >
            <AddressAutocompleteResultRow
              display={result.display}
              focused={isBottomSheet ? false : index === focusedIndex}
              isBottomSheet={isBottomSheet}
              searchValue={searchValue}
            />
          </li>
        ))}
      </ul>
      {showGoogleAttribution && searchValue && results.length > 0 && (
        <Layout justify="flex-end" {...(isBottomSheet ? { marginTop: 8, paddingRight: 24 } : { paddingRight: 8 })}>
          <Layout {...(isBottomSheet ? { width: 100 } : { width: 120 })}>
            <img src={poweredByGoogle} alt="Powered by Google" />
          </Layout>
        </Layout>
      )}
    </Layout>
  );
};

export default AddressAutocompleteResults;
